module.exports = __webpack_public_path__ + "static/IMG_4931-37405ef60054c41d2f37e92b9e835822.jpg";